export const journeyTypeLabel = (journey) => {
  const details = [journey.journey_type, ...(journey.booking_details || [])]
    .filter(Boolean)
    .join(" ");
  if (/wait(?:ing)?\s*(?:and|&|\/)\s*return/i.test(details))
    return "Wait and return";
  return journey.journey_type || "Journey type not provided";
};
